import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IConfigOptions } from '../../../models/IConfigOptions';
import { IMenuOptions } from '../../../models/IMenuOptions';
import { IMenuIcon, DefaulIconValues } from '../../../models/IMenuIcon';

@Component({
  selector: 'ff-three-dot-menu',
  templateUrl: './three-dot-menu.component.html',
  styleUrls: ['./three-dot-menu.component.scss']
})
export class ThreeDotMenuComponent implements OnInit{

  /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
  */
  @Input() upperList: IMenuOptions[];

  /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
  */
  @Input() lowerList?: IMenuOptions[];


      /**
   * Options to display as options in the dropdown
   * Use the IConfigOptions interface: { disabled: boolean; }
   * * @internal
  */
  @Input() config?: IConfigOptions;

  /**
   * Options to display a specific icon
   * * Use the IMenuIcon
   * * @internal
  */
  @Input() iconConfig?: IMenuIcon;

  toggledMenu : boolean = false;

  //boolean variable to control disabled property of the component
  isDisabled: boolean = false;
  //string icon
  componentIconName: string;
  //string color
  componentIconColor: string;

  constructor() {

  }

  ngOnInit() {
    this.componentIconName =
      this.iconConfig?.hasOwnProperty("icon") ? this.iconConfig.icon : DefaulIconValues.Icon;
    this.componentIconColor =
      this.iconConfig?.hasOwnProperty("color") ? this.iconConfig.color : DefaulIconValues.Color;
    this.isDisabled = this.config != undefined ? this.config.disabled : false;
  }

  menuChange() {
    this.toggledMenu = !this.toggledMenu;
  }

}
